import { createSelector } from '@reduxjs/toolkit';

import settings from '~/settings';
import { SEASON_TYPES } from '~/constants';

import type { RootState } from '~/store';

export const fameRatingsSelector = (state: RootState) => state.ReducerHallFame.ratings;

const fameWinnersSelector = (state: RootState) => state.ReducerHallFame.winnersList;

export const fameSeasonNamesSelector = createSelector(fameWinnersSelector, (winnersList) => {
  const seasonName: Record<number, string> = {};
  const seasons = settings.ladder?.seasons || {};

  if (seasons) {
    const localization = settings.realm.languageCodeGloss;
    const hasStatisticsForSeason = (seasonNumber: number) => winnersList[seasonNumber] !== undefined;

    for (const seasonNumber in seasons) {
      const season = seasons[seasonNumber];
      if (hasStatisticsForSeason(Number(seasonNumber)) && season?.kind === SEASON_TYPES.REGULAR) {
        seasonName[seasonNumber] = seasons[seasonNumber]?.localization.title[localization] || '';
      }
    }
  }

  return {
    winnersList,
    seasonName,
  };
});
